var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.7656C12.4173 14.7656 15.1875 11.9954 15.1875 8.57812C15.1875 5.16086 12.4173 2.39062 9 2.39062C5.58274 2.39062 2.8125 5.16086 2.8125 8.57812C2.8125 11.9954 5.58274 14.7656 9 14.7656ZM9 15.8906C13.0386 15.8906 16.3125 12.6167 16.3125 8.57812C16.3125 4.53954 13.0386 1.26562 9 1.26562C4.96142 1.26562 1.6875 4.53954 1.6875 8.57812C1.6875 12.6167 4.96142 15.8906 9 15.8906ZM4.50004 8.57804C4.50004 8.26738 4.75188 8.01554 5.06254 8.01554H8.43751V4.64061C8.43751 4.32995 8.68935 4.07811 9.00001 4.07811C9.31067 4.07811 9.56251 4.32995 9.56251 4.64061V8.01554H12.9375C13.2482 8.01554 13.5 8.26738 13.5 8.57804C13.5 8.8887 13.2482 9.14054 12.9375 9.14054H9.56251V12.5156C9.56251 12.8263 9.31067 13.0781 9.00001 13.0781C8.68935 13.0781 8.43751 12.8263 8.43751 12.5156V9.14054H5.06254C4.75188 9.14054 4.50004 8.8887 4.50004 8.57804Z",
    fill: "#F9FAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWhite);
export default __webpack_public_path__ + "static/media/add-white.8fa9df29a1db4b54b0907ad81c5dd202.svg";
export { ForwardRef as ReactComponent };